define('views/AlertView',['require','exports','module','views/BaseView','ldsh!../templates/alert'],function(require, exports, module) {
    'use strict';

    var BaseView = require('views/BaseView');

    var icons = {
        success: 'fa-check-circle-o',
        danger: 'fa-times-circle-o'
    };

    var AlertView = BaseView.extend({
        template: require('ldsh!../templates/alert'),
        serialize: function() {
            return {
                type: this.options.type,
                msg: this.options.msg,
                msg_lang: this.options.msg_lang,
                icon: icons[this.options.type]
            };
        }
    });

    module.exports = AlertView;
});

